import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardText,
  CardTitle,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';
import { UnitPcvItemList } from '../models/unitPcv';
import UnitPcvEditModal from './UnitPcvEditModal';
import UnitPcvFinantialModal from './UnitPcvFinantialModal';
import { UnitPcvStatusBadge } from './UnitPcvStatusBadge';
import { UnitPCVStatus } from '../enums/UnitPcvEnum';
import { useNavigate } from 'react-router-dom';
import useModalState from '../../../hooks/useModalState';

interface Props {
  pcv: UnitPcvItemList;
}

const UnitPcvListCard = ({ pcv }: Props) => {
  const navigate = useNavigate();
  const [showFinantialModal, toggleFinantialModal] = useModalState();
  const financesConfig: boolean =
    pcv.finantial !== null && pcv.finantial.down_payment_paid > 0;
  return (
    <Card>
      <CardHeader>
        <div className="d-flex justify-content-between align-items-center">
          <CardTitle tag="h5" className="mb-0 text-capitalize">
            #{pcv.code} - {pcv.name} - {pcv.model_name}
          </CardTitle>
          <UnitPcvStatusBadge status={pcv.status as UnitPCVStatus} />
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">{pcv.base_price_formatted}</small>
          {pcv.ref_model_unit_id && (
            <small className="text-muted">*Unidad migrada del proyecto</small>
          )}
        </div>
        <div className="mt-1">
          <div>
            <small className="text-muted">
              <i className="ni ni-single-02 mr-1" />
              {pcv.landlordInfo.name}
            </small>
          </div>
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            <small className="text-muted">
              <i className="ni ni-email-83 mr-1" />
              <a
                href={`mailto:${pcv.landlordInfo.email}`}
                className="text-muted"
              >
                {pcv.landlordInfo.email}
              </a>
            </small>
            <small className="text-muted">
              <i className="ni ni-mobile-button mr-1" />
              <a href={`tel:${pcv.landlordInfo.phone}`} className="text-muted">
                {pcv.landlordInfo.phone}
              </a>
            </small>
          </div>
        </div>
      </CardHeader>
      <CardBody>
        <CardText>
          <Badge className="badge-lg my-2" color="primary" pill>
            <i className="fa fa-duotone fa-square"></i> {pcv.area} mt
            <sup>2</sup>
          </Badge>
          {pcv.square_rods !== 0 && (
            <Badge className="badge-lg my-2" color="primary" pill>
              <i className="fa fa-duotone fa-square"></i> {pcv.square_rods} v
              <sup>2</sup>
            </Badge>
          )}

          <Badge className="badge-lg my-2" color="primary" pill>
            <i className="fa fa-duotone fa-toilet"></i> {pcv.bathrooms} baños
          </Badge>
          <Badge className="badge-lg my-2" color="primary" pill>
            <i className="fa fa-duotone fa-bed"></i> {pcv.bedrooms} cuartos
          </Badge>
          {pcv.level !== null && pcv.level > 0 && (
            <Badge className="badge-lg my-2" color="primary" pill>
              <i className="fa fa-duotone fa-building"></i> {pcv.level} piso
            </Badge>
          )}
        </CardText>
      </CardBody>
      <CardFooter>
        <div className="d-flex align-items-center">
          <span className="mr-2">
            <UnitPcvEditModal pcv={pcv} financesConfig={financesConfig} />
          </span>
          <UncontrolledDropdown>
            <DropdownToggle color="secondary" size="sm" caret>
              Más acciones
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                onClick={() => {
                  navigate(`/pcvs/${pcv.id}/upload-media`);
                }}
              >
                <i className={'ni ni-image mr-2'} /> Administrar media
              </DropdownItem>
              <DropdownItem onClick={() => {}}>
                <i className={'ni ni-calendar-grid-58 mr-2'} /> Administrar
                asesorias
              </DropdownItem>
              <DropdownItem onClick={() => {}}>
                <i className={'ni ni-calendar-grid-58 mr-2'} /> Administrar
                pre-reservas
              </DropdownItem>
              <DropdownItem onClick={toggleFinantialModal}>
                <i className={'ni ni-money-coins mr-2'} /> Administrar datos
                financieros
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          {!financesConfig && (
            <Badge color="warning" pill className="ml-auto">
              <i className="ni ni-money-coins mr-1" /> Datos financieros
              pendientes
            </Badge>
          )}
        </div>
      </CardFooter>
      <UnitPcvFinantialModal
        pcv={pcv}
        isOpen={showFinantialModal}
        toggle={toggleFinantialModal}
      />
    </Card>
  );
};

export default UnitPcvListCard;
